import { env } from '@/constants/env';

export const getRenderingImage = (taskId: string) => {
  return fetch(`${env.AI_API_URL}/result/${taskId}`, {
    headers: {
      auth: `Bearer ${env.AI_API_TOKEN}`,
    },
  });
};
